import { HttpClient } from '../HttpClient';
/**
 * * Patch Projects
 */
export const PatchProjects = async (projectId, patchData) => {
  try {
    const { data } = await HttpClient.patch(`api/projects/${projectId}`, {
      ...patchData,
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
